import { Pipe, PipeTransform } from '@angular/core';

// Example: ('sub-class1 sub-class2' | addClassList:{mainClass: 'main-class--'})
// Result: 'main-class--sub-class1 main-class--sub-class2'

@Pipe({
  name: 'addClassList',
  standalone: false
})
export class AddClassListPipe implements PipeTransform {
  transform(classList: string, args: { mainClass: string }): string {
    let classes;
    let classesLine = '';

    if (classList) {
      classes = classList.split(' ');

      classes.map((className) => {
        classesLine += ' ' + args.mainClass + className;
      });
    }

    return classesLine;
  }
}
